import React from 'react';
import PropTypes from 'prop-types';
import { Card } from 'semantic-ui-react';
import Avatar from 'react-avatar';
import _ from 'lodash';

import FeedEvent, {
  FeedTitleAndDescription,
} from './feed-event';

const avatarStyle = {
  float: 'left',
  marginRight: 20,
};

const UserAddedEvent = ({
  isCompact,
  messageData: {
    resource: {
      createdBy,
      createdDate,
      name,
      role,
    },
  },
}) => (
  <FeedEvent
    isCompact={isCompact}
    actionText="added a new user"
    createdBy={createdBy}
    createdDate={createdDate}
  >
    <Card fluid>
      <Card.Content>
        <Avatar
          round
          name={name}
          size={50}
          style={avatarStyle}
        />
        <FeedTitleAndDescription
          title={name}
          description={_.startCase(_.lowerCase(role))}
        />
      </Card.Content>
    </Card>
  </FeedEvent>
);

UserAddedEvent.propTypes = {
  messageData: PropTypes.object.isRequired,
  isCompact: PropTypes.bool.isRequired,
};

export default UserAddedEvent;



/** WEBPACK FOOTER **
 ** ./src/containers/event-feed/card-events/user-added-event.js
 **/